import React from "react";
import { useRetrieveProjectPortfolios } from "@planzone/view-models";
import { Identifiable, Project, ProjectPortfolio } from "@planzone/dto";

import { ProjectPortfolioTag } from "@common/projectPortfolioTag";
import { SelectList } from "@common/selectList";
import { PortfolioAssignation } from "@common/portfolioAssignation";
import { Props } from "./types";
import { AddIcon } from "./addIcon";
import styles from "./styles.scss";

function extractAssignedPortfolios(
  project: Identifiable<Project>,
  portfolios: Identifiable<ProjectPortfolio>[],
): Identifiable<ProjectPortfolio>[] {
  return portfolios.reduce<Identifiable<ProjectPortfolio>[]>(
    (sum, portfolio) =>
      !!portfolio.projects.find(({ uuid }) => uuid === project.uuid)
        ? [...sum, portfolio]
        : sum,
    [],
  );
}

function ProjectPortfoliosList({ project, isRemovable, remove }: Props) {
  const { portfolios } = useRetrieveProjectPortfolios();
  const assignedPortfolios = extractAssignedPortfolios(project, portfolios);

  return (
    <div className={styles.projectPortfoliosList}>
      {assignedPortfolios.map((portfolio) => (
        <div key={portfolio.uuid} className={styles.item}>
          <ProjectPortfolioTag
            {...portfolio}
            isRemovable={isRemovable}
            remove={() => remove && remove(portfolio)}
          />
        </div>
      ))}
      <div className={styles.item}>
        <SelectList inputClassName={styles.input} listClassName={styles.list}>
          {() => ({
            input: <AddIcon className={styles.icon} />,
            list: <PortfolioAssignation project={project} />,
          })}
        </SelectList>
      </div>
    </div>
  );
}

export { ProjectPortfoliosList };
